import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';

const CustomLink = ({ href, asPath, children }) => {
  const router = useRouter();

  let className = children.props.className || '';

  if (router.asPath === asPath) {
    className = `${className || ''} selected`;
  }

  return (
    <Link href={href} as={asPath}>
      {React.cloneElement(children, { className })}
    </Link>
  );
};

export default CustomLink;
